<template>
  <div
    class="content"
    :style="
      extraItem.extras('activityTheme.display') == 1 ||
      extraItem.extras('activityTime.display') == 1 ||
      extraItem.extras('activityPlace.display') == 1 ||
      extraItem.extras('activitySchedule.display') == 1 ||
      platform == 'wap'
        ? ''
        : 'width:80%'
    "
  >
    <div
      class="u-success"
      :style="{
        display: extraItem.extras('successImg.display') == 0 ? 'none' : 'block',
      }"
    >
      <img :src="extraItem.extras('successImg.src')" alt="" />
    </div>
    <div
      class="t-success"
      :style="{
        color: extraItem.extras('successTitle.color'),
        fontSize: pxOrVw(extraItem.extras('successTitle.size')),
        fontWeight:
          extraItem.extras('successTitle.weight') == 'default'
            ? '500'
            : extraItem.extras('successTitle.weight'),
        display:
          extraItem.extras('successTitle.display') == 0 ? 'none' : 'block',
      }"
    >
      {{ extras | extra("successTitle.model") }}
    </div>
    <div
      class="t-success-desc"
      :style="{
        color: extraItem.extras('successText.color'),
        fontSize: pxOrVw(extraItem.extras('successText.size')),
        fontWeight:
          extraItem.extras('successText.weight') == 'default'
            ? '400'
            : extraItem.extras('successText.weight'),
        display:
          extraItem.extras('successText.display') == 0 ? 'none' : 'block',
      }"
    >
      {{ extras | extra("successText.model") }}
    </div>
  </div>
</template>
<script>
export default {
  name: "SuccessCon",
  props: ["platform"],
  computed: {
    extras() {
      return this.$store.state.extras;
    },
  },
};
</script>
